// Referral (invited-org discount) strings for GetPaid: the pre-onboarding
// "have a referral code?" prompt, the permanent add/locked referral card
// (onboarding page), and the shared apply/error copy both reuse. EN is the
// source of truth — every key here MUST have a native-Portuguese counterpart
// in referral.pt-BR.ts.
const referral: Record<string, string> = {
  // Pre-onboarding prompt
  'referral.prompt.title': 'Have a referral code?',
  'referral.prompt.pitch': 'Add it now and get 50% off our fee for your first 30 days of payments.',
  'referral.prompt.dismiss': "I don't have one",
  'referral.prompt.active': 'Referral discount active — 50% off our fee for your first month',
  'referral.prompt.activeUntil':
    'Referral discount active — 50% off our fee for your first month, until {date}',

  // Permanent referral card (add / locked states)
  'referral.card.title': 'Add a referral code',
  'referral.card.pitch': 'Add it now and get 50% off our fee for your first 30 days of payments.',
  'referral.card.placeholder': 'Referral code',
  'referral.card.apply': 'Apply',
  'referral.card.lockedTitle': 'Referral code',
  'referral.card.lockedBody': 'Referral code added on {date}. This can never be changed.',
  'referral.card.lockedBodyNoDate': 'A referral code is on file. This can never be changed.',

  // Shared apply errors (400 / 409)
  'referral.error.invalid': "That code isn't valid.",
  'referral.error.selfReferral': "You can't use your own referral code.",
  'referral.error.alreadySet': 'A referral code is already set on this account.',
  'referral.error.generic': 'Could not add that code. Please try again.',
};

export default referral;
